import { LocalizedCurrencyValue } from '@mews/framework';
import { getCurrentEnterpriseDefaultCurrencyCode } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { useCommanderSelector } from '@mews-commander/utils';

interface LocalizedCurrencyValueIntegerProps {
    value: number;
    className?: string;
}

export const LocalizedCurrencyValueInteger = ({ value, ...props }: LocalizedCurrencyValueIntegerProps) => {
    const enterpriseCurrency: string = useCommanderSelector(getCurrentEnterpriseDefaultCurrencyCode);

    return (
        <LocalizedCurrencyValue
            value={{
                value,
                currency: enterpriseCurrency,
            }}
            options={{
                precision: 0,
            }}
            {...props}
        />
    );
};
